document.querySelectorAll('[data-mayam-product]').forEach(root => {
  const form = root.querySelector('.my-buy-form');
  const buy = root.querySelector('[data-mayam-add]');
  const host = root.querySelector('[data-mayam-cod-host]');
  const sticky = root.querySelector('[data-mayam-sticky]');
  let hostVisible = true;
  buy.hidden = true;
  sticky.hidden = true;
  form.addEventListener('submit', event => { event.preventDefault(); });
  const sync = () => {
    const variantId = root.querySelector('[data-mayam-variant]').value;
    const productId = form.querySelector('input[name="product-id"]').value;
    host.querySelectorAll('input[name="id"]').forEach(el => { el.value = variantId; });
    host.querySelectorAll('input[name="product-id"]').forEach(el => { el.value = productId; });
    const appBuy = host.querySelector('#rsi_buy_now_button');
    if (appBuy) appBuy.classList.toggle('mayam-cod-fixed', !hostVisible);
  };
  new MutationObserver(sync).observe(host, {childList:true, subtree:true});
  new IntersectionObserver(entries => { hostVisible = entries[0].isIntersecting; sync(); }, {threshold:0.05}).observe(host);
  sync();
});
document.querySelectorAll('[data-mayam-sort]').forEach(select => select.addEventListener('change', () => {
  const url = new URL(location.href); url.searchParams.set('sort_by',select.value); url.searchParams.delete('page'); location.assign(url.href);
}));
document.querySelectorAll('.mc-footer a[href*="#"], .mc-mobile-menu a[href*="#"]').forEach(link => link.addEventListener('click', () => {
  const id = new URL(link.href).hash.slice(1); const target = document.getElementById(id);
  if (target?.tagName === 'DETAILS') target.open = true;
}));
if (location.hash) { const target = document.getElementById(location.hash.slice(1)); if (target?.tagName === 'DETAILS') target.open = true; }
